"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = makeEngagementAssociationSelect;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = require("immutable");

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _underscore = require("underscore");

var _ObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ObjectTypesType"));

var _generalStore = require("general-store");

var _reactImmutableRenderMixin = _interopRequireDefault(require("react-immutable-render-mixin"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _colors = require("HubStyleTokens/colors");

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _UIAvatar = _interopRequireDefault(require("ui-addon-avatars/UIAvatar"));

var _EngagementAssociationsConstants = require("crm_data/associations/EngagementAssociationsConstants");

var _LoadingStatus = require("crm_data/flux/LoadingStatus");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _defer = _interopRequireDefault(require("q/js/lib/defer"));

var _createStatefulWrapper = _interopRequireDefault(require("crm_ui/utils/createStatefulWrapper"));

var _ObjectTypes = _interopRequireDefault(require("customer-data-objects/constants/ObjectTypes"));

var initialState = {
  searchText: '',
  searchLength: 0
};

function makeEngagementAssociationSelect(_ref) {
  var name = _ref.name,
      OptionsDependency = _ref.OptionsDependency,
      associatedObjectType = _ref.associatedObjectType;
  var EngagementAssociationsSelect = (0, _createReactClass.default)({
    displayName: name,
    mixins: [_reactImmutableRenderMixin.default],
    propTypes: {
      autoload: _propTypes.default.bool,
      handleRemove: _propTypes.default.func.isRequired,
      handleSelect: _propTypes.default.func.isRequired,
      isBET: _propTypes.default.bool,
      filterOptions: _propTypes.default.bool,
      minimumSearchLength: _propTypes.default.number,
      objectType: _ObjectTypesType.default,
      optionMatches: _propTypes.default.array,
      placeholderText: _propTypes.default.string.isRequired,
      setState: _propTypes.default.func.isRequired,
      state: _propTypes.default.shape({
        searchText: _propTypes.default.string.isRequired,
        searchLength: _propTypes.default.number.isRequired
      }).isRequired,
      subjectId: _propTypes.default.string,
      value: _propTypes.default.array,
      enableMultiSelect: _propTypes.default.bool
    },
    getDefaultProps: function getDefaultProps() {
      return {
        autoload: true,
        isBET: false,
        filterOptions: true,
        minimumSearchLength: 0,
        state: initialState,
        enableMultiSelect: true
      };
    },
    componentWillMount: function componentWillMount() {
      this.resetPromise();
    },
    componentWillReceiveProps: function componentWillReceiveProps(_ref2) {
      var optionMatches = _ref2.optionMatches;

      if ((0, _LoadingStatus.isResolved)(optionMatches) && optionMatches !== this.props.optionMatches) {
        var optionsWithAvatars = this.includeAvatarProperties(optionMatches);
        this.resolvePromise({
          options: optionsWithAvatars
        });
      }
    },
    resetPromise: function resetPromise() {
      this._deferredOptions = (0, _defer.default)();
    },
    resolvePromise: function resolvePromise(value) {
      this._deferredOptions.resolve(value);
    },
    includeAvatarProperties: function includeAvatarProperties(matches) {
      if (!matches) {
        return matches;
      }

      return matches.map(function (option) {
        var record = option.record;

        if (!record) {
          return option;
        }

        var type = (0, _ImmutableModel.getObjectType)(record);
        var id = (0, _ImmutableModel.getId)(record);

        var avatarProps = function () {
          switch (type) {
            case _ObjectTypes.default.CONTACT:
              return {
                vid: id
              };

            case _ObjectTypes.default.COMPANY:
              return {
                companyId: id
              };

            case _ObjectTypes.default.DEAL:
              return {
                type: _ObjectTypes.default.DEAL.toLowerCase()
              };

            default:
              return {};
          }
        }();

        option.avatar = _react.default.createElement(_UIAvatar.default, (0, _extends2.default)({
          displayName: (0, _ImmutableModel.toString)(record)
        }, avatarProps, {
          size: "xs"
        }));
        return option;
      });
    },
    parseValue: function parseValue(value) {
      if (!value || value.length === 0) {
        return undefined;
      }

      var _ref3 = this.props.enableMultiSelect ? (0, _underscore.first)(value).split(' ') : value.split(' '),
          _ref4 = (0, _slicedToArray2.default)(_ref3, 2),
          objectType = _ref4[0],
          subjectId = _ref4[1];

      return [objectType, Number(subjectId)];
    },
    addValue: function addValue(value) {
      var _this$parseValue = this.parseValue(value),
          _this$parseValue2 = (0, _slicedToArray2.default)(_this$parseValue, 2),
          objectType = _this$parseValue2[0],
          subjectId = _this$parseValue2[1];

      this.props.handleSelect(objectType, subjectId);
    },
    removeValue: function removeValue(value) {
      var removedValue = (0, _underscore.without)(value, this.props.objectType + " " + this.props.subjectId);

      var _this$parseValue3 = this.parseValue(removedValue),
          _this$parseValue4 = (0, _slicedToArray2.default)(_this$parseValue3, 2),
          objectType = _this$parseValue4[0],
          subjectId = _this$parseValue4[1];

      this.props.handleRemove(objectType, subjectId);
    },
    getBETAssociationObject: function getBETAssociationObject(value) {
      var valueText = this.props.optionMatches.find(function (match) {
        return value[0] === match.value;
      });
      return (0, _immutable.Map)({
        objectId: value[0],
        label: valueText.text
      });
    },
    handleSelect: function handleSelect(_ref5) {
      var value = _ref5.target.value;
      var _this$props = this.props,
          isBET = _this$props.isBET,
          handleSelect = _this$props.handleSelect,
          handleRemove = _this$props.handleRemove,
          enableMultiSelect = _this$props.enableMultiSelect;

      if (!enableMultiSelect) {
        return this.addValue(value);
      }

      var addedValue = (0, _underscore.difference)(value, this.props.value);
      var removedValue = (0, _underscore.difference)(this.props.value, value);

      if (addedValue.length) {
        if (isBET) {
          return handleSelect(this.getBETAssociationObject(addedValue));
        }

        return this.addValue(addedValue);
      }

      if (isBET) {
        return handleRemove(this.getBETAssociationObject(removedValue));
      }

      return this.removeValue(removedValue);
    },
    handleInputValueChange: function handleInputValueChange(evt) {
      var searchText = evt.target.value;
      var searchLength = searchText.length;
      this.props.setState({
        searchText: searchText,
        searchLength: searchLength
      });
    },
    handleLoadOptions: function handleLoadOptions(searchText, callback) {
      var minimumSearchLength = this.props.minimumSearchLength;
      var searchLength = searchText.length; // TODO remove once handleInputValueChange works

      this.props.setState({
        searchText: searchText,
        searchLength: searchLength
      });

      if (searchLength > 0) {
        this.resetPromise();
      }

      if (searchLength < minimumSearchLength) {
        callback(null);
      }

      return this._deferredOptions.promise;
    },
    handleOpenChange: function handleOpenChange(evt) {
      var isOpening = evt.target.value;

      if (isOpening) {
        this.props.setState({
          searchText: ''
        });
      }
    },
    getNoResultsText: function getNoResultsText() {
      var minimumSearchLength = this.props.minimumSearchLength;
      var searchLength = this.props.state.searchLength;

      if (searchLength === 0) {
        return undefined;
      } else if (searchLength < minimumSearchLength) {
        var charsNeeded = minimumSearchLength - searchLength;
        return _I18n.default.text('salesUI.UISearchInput.minimumSearchMessage', {
          count: charsNeeded
        });
      }

      return undefined;
    },
    render: function render() {
      var _this$props2 = this.props,
          autoload = _this$props2.autoload,
          filterOptions = _this$props2.filterOptions,
          isBET = _this$props2.isBET,
          objectType = _this$props2.objectType,
          optionMatches = _this$props2.optionMatches,
          placeholderText = _this$props2.placeholderText,
          state = _this$props2.state,
          value = _this$props2.value,
          enableMultiSelect = _this$props2.enableMultiSelect;
      var shouldDisableSelect = optionMatches && !optionMatches.length && !state.searchText;
      var bet = isBET ? 'bet.' : '';
      return _react.default.createElement(_UIFlex.default, {
        align: "center"
      }, _react.default.createElement(_UIIcon.default, {
        name: "add",
        color: _colors.EERIE
      }), _react.default.createElement(_UITooltip.default, {
        title: _react.default.createElement(_FormattedHTMLMessage.default, {
          message: bet + "associations.disabledSelectTooltip." + associatedObjectType,
          options: {
            objectType: _I18n.default.text("genericTypes.singular." + objectType)
          }
        }),
        disabled: !shouldDisableSelect
      }, _react.default.createElement("div", null, _react.default.createElement(_UISelect.default, {
        anchorType: "button",
        "data-selenium-test": "EngagementAssociationSelect",
        "data-selenium-test-bet": "EngagementAssociationSelect-" + associatedObjectType,
        disabled: shouldDisableSelect,
        backspaceRemoves: false,
        multi: enableMultiSelect,
        buttonUse: "transparent",
        className: "p-left-1 p-top-2",
        menuWidth: _EngagementAssociationsConstants.SELECT_MENU_WIDTH,
        minimumSearchCount: 0,
        onChange: this.handleSelect,
        onOpenChange: this.handleOpenChange,
        onInputValueChange: this.handleInputValueChange,
        placeholder: placeholderText,
        _forcePlaceholder: true,
        loadOptions: this.handleLoadOptions,
        value: value,
        noResultsText: this.getNoResultsText(),
        autoload: autoload,
        filterOptions: filterOptions
      }))));
    }
  });
  var ConnectedEngagementAssociationSelect = (0, _generalStore.connect)({
    optionMatches: OptionsDependency
  })(EngagementAssociationsSelect);
  return (0, _createStatefulWrapper.default)(initialState, ConnectedEngagementAssociationSelect);
}

module.exports = exports.default;